import React, { useState, useEffect } from 'react'
import { oktmo2name, datetime, fixHtml } from './Utils'

export default function Table(props) {
	
	const { data, ENV, eventIconName, dialogs, onShowEventDetails } = props
	
	const [active, setActive] = useState([])
	
	useEffect(() => {
		setActive(dialogs.map(e => e.active))
	}, [dialogs])
	
	const format = (title, cur, max) => (cur || max) && <p className="flex nowrap">
		<span className="p-0 mr-2 col-5">{title}</span>
		<span className="p-0 col">{cur || '0'} {max && max != cur && <span className="text-gray-400">( {max} макс )</span>}</span>
	</p>
	
	return <div className="description-table">
		<table>
			<thead>
				<tr>
					<th>{''}</th>
					<th>{'Регион'}</th>
					<th>{'Событие'}</th>
					<th>{'Описание'}</th>
					<th>{'Начало'}</th>
					<th>{'Завершение'}</th>
				</tr>
			</thead>
			<tbody>
				{data.fEvents.map((e, i) => <tr key={i} className={active.includes(e.id) ? 'active' : ''}>
					<td className="pt-2">
						<img className="icon" src={`${ENV.imgUrl}${eventIconName(e)}.svg`} onClick={() => {
							window.scroll({top: 0, behavior: 'instant'})
							document.getElementById('top-filters-bar').scrollIntoView({behavior: 'instant'})
							onShowEventDetails([e.id])
						}}/>
					</td>
					<td>
						{e.regions.replace('{', '').replace('}', '').split(',').map((r, i) => oktmo2name[r].replaceAll(' ', ' ')).map((e, i) => <p key={i}>{e}</p>)}
					</td>
					<td>
						{e.title.map((t, i) => <p key={i}>{t}</p>)}
						{(e.disabled_consumers || e.max_disabled_consumers || e.disabled_endpoints || e.max_disabled_endpoints || e.cut_off_power || e.max_cut_off_power) && <div className="border-top"></div>}
						{format('потребители', e.disabled_consumers, e.max_disabled_consumers)}
						{format('т. поставки', e.disabled_endpoints, e.max_disabled_endpoints)}
						{format('мощность', e.cut_off_power, e.max_cut_off_power)}
					</td>
					<td>
						<div className="description-no-style" dangerouslySetInnerHTML={{ __html: fixHtml(e.description) }}></div>
					</td>
					<td>
						{datetime(e.ds)}
					</td>
					<td>
						{e.de ? datetime(e.de) : <span className="text-red-600">{'не завершено'}</span>}
					</td>
				</tr>)}
			</tbody>
		</table>
	</div>
		
}

